"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLegacyPlan = void 0;
const status_1 = __importDefault(require("../constants/status"));
/**
 * Check if the provided plan will require a migration.
 *
 * @param plan The Plan object retrieved from the billing-service.
 *
 * @return `false` if the status is `ACTIVE`, `true` otherwise.
 */
const isLegacyPlan = (plan) => {
    if (!plan) {
        return false;
    }
    return plan.status !== status_1.default.Active;
};
exports.isLegacyPlan = isLegacyPlan;
